import {
  hexToRGB,
  MOON_250,
  TEAL_450,
  TEAL_500,
  TEAL_550,
  WHITE,
} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const ModalHeaderWrapper = styled.div`
  font-size: 24px;
  font-weight: 600;
  padding: 1.5rem 2rem;
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 2rem 2rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  padding-top: 1rem;
  button {
    font-weight: 600 !important;
    border: none !important;
    background: none !important;
    &:hover {
      background-color: ${hexToRGB(TEAL_500, 0.1)} !important;
      color: ${TEAL_550} !important;
    }
  }
  button[type='submit']:not([disabled]) {
    background-color: ${TEAL_500} !important;
    &:hover {
      background-color: ${TEAL_450} !important;
      color: ${WHITE} !important;
    }
  }
`;

export const InputErrorMessage = styled.p`
  padding-top: 6px;
  font-size: 14px;
  color: #9f3a38;
`;

export const EmailAndRoleWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  label {
    margin-bottom: 0.75rem !important;
    font-weight: 600 !important;
  }
`;

export const EmailInputWrapper = styled.div`
  flex: 2;
  .field input {
    box-shadow: none !important;
    height: 42px;
    &:focus {
      border-color: ${TEAL_500} !important;
    }
  }
  .field.error input:focus {
    border-color: #9f3a38 !important;
  }
`;

export const UserRoleDropdown = styled.div`
  flex: 1;
  .ui.dropdown {
    height: 40px;
    border: 1px solid ${MOON_250};
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    &[aria-expanded='true'] {
      border-color: ${TEAL_500};
    }

    .visible.menu {
      top: 103%;
      width: 100%;
    }
  }
`;

export const UserRoleLabel = styled.label`
  display: block;
`;
